var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sa-flex-page"},[_c('div',{staticClass:"sa-flex-page-header"},[_vm._t("header")],2),_c('div',{staticClass:"sa-flex-page-body"},[_vm._t("body")],2),_c('div',{staticClass:"sa-flex-page-footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }